import UpdateIOUDisbursement from "../UpdateIOUDisbursement/UpdateIOUDisbursement";

const ViewIOUDisbursement = (props) => {
  return <UpdateIOUDisbursement {...props} viewMode={true} />;
};

export default ViewIOUDisbursement;
